import React from 'react'
import styles from './style.module.scss'

import chevronDown24SVG from 'assets/images/chevron-down-24.svg'
import chevronRight24SVG from 'assets/images/chevron-right-24.svg'
import plusIcon24SVG from 'assets/images/plus-24.svg'

import Avatar from 'pages/calendar/components/Avatar'
import { Dropdown, Menu, Tooltip } from 'antd'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

interface AccountInfoViewProps {
  name: string
  email: string
  count?: number
  expanded: boolean
  onExpandClick: (expanded: boolean) => void
  onAddClick?: () => void
  onAddSubscriptionClick?: () => void
  onNotiClick?: () => void
}

const AccountInfoView: React.FC<AccountInfoViewProps> = ({
  name,
  email,
  count = 0,
  expanded,
  onExpandClick,
  onAddClick,
  onAddSubscriptionClick,
  onNotiClick,
}) => {
  const { t } = useTranslation()

  const addMenuItems = [
    {
      key: 'newCalendar',
      label: t('calendar.folder.newCalendar'),
      onClick: () => onAddClick?.(),
    },
    {
      key: 'newSubscription',
      label: t('calendar.folder.newSubscription'),
      onClick: () => onAddSubscriptionClick?.(),
    },
  ]

  const addMenu = <Menu items={addMenuItems} className={classNames(styles.contextMenu)} />

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.avatar}>
          <Avatar {...({ size: 32, name: name, email: email, skipLogo: true } as any)} />
        </div>
        <div className={styles.info}>
          <div className={styles.nameRow}>
            <Tooltip title={email}>
              <span className={styles.name}>{name}</span>
            </Tooltip>
            <div className={styles.right}>
              {count > 0 && (
                <span className={styles.count} onClick={onNotiClick}>
                  {count}
                </span>
              )}
              {onAddClick && onAddSubscriptionClick && (
                <Dropdown
                  {...({} as any)}
                  popupRender={() => addMenu}
                  trigger={['click']}
                  placement="bottomRight"
                  overlayClassName={'contextMenu'}
                >
                  <button className={styles.addButton} onClick={(e) => e.preventDefault()}>
                    <img src={plusIcon24SVG} alt="add" />
                  </button>
                </Dropdown>
              )}
              {onAddClick && !onAddSubscriptionClick && (
                <button className={styles.addButton} onClick={() => onAddClick()}>
                  <img src={plusIcon24SVG} alt="add" />
                </button>
              )}
            </div>
          </div>
        </div>
        <button
          className={styles.expandButton}
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
            onExpandClick(!expanded)
          }}
        >
          <img
            src={expanded ? chevronDown24SVG : chevronRight24SVG}
            alt="expand"
            className={styles.expandIcon}
          />
        </button>
      </div>
    </div>
  )
}

export default AccountInfoView
